var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"the-logotype"},[_c('router-link',{staticClass:"the-logotype__image",attrs:{"to":"/","title":"數據看選舉"}},[_c('SvgSymbol',{attrs:{"use":"#logotype"}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }